<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2012</span></div>
    </div>
    <div class="view-wrap yr2012">


<FullYearStats fullGames='16' fullCompletions='422' fullAttempts='670' fullYards='5,177' fullPct='63.0' fullTDs='43' fullINTs='19' fullYPG='323.6' fullRating='96.3'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">

           <h1 class="content-headline">Touchdown machine</h1>

      <div class="copy-paragraph">
      
      Brees was elected to his fifth consecutive Pro Bowl as he completed 422-of-670 passes (63.0%) for 5,177 yards with 43 touchdown passes and a 96.3 passer rating. Brees led the NFL in yardage, touchdown passes, and completions of 25 yards or more (47).
      <br/><br/>

      On October, Brees broke Johnny Unitas' streak of 47 straight games with a touchdown pass, a record that stood since 1960.<br/><br/>

      Brees would become the first NFL player to throw for at least 5,000 yards in three seasons. Drew's yardage total was the third highest single-season figure in NFL history at the time (Drew currently holds 5 of the top 8 single-season passing yardage totals).
      <br/><br/>

Brees' touchdown total was the second highest of his career (47 in 2011), at the time making him and Dan Marino the only two players in NFL history with at least two seasons with 40 or more touchdowns. 
      <br/><br/>

      Despite a year full of controversy and distractions, Brees turned in another statistically dominant season. Ultimately though, the Saints couldn't overcome their situation, finishing 7-9.
       <br/><br/>

      </div>

      <div class="copy-paragraph">

      <img :src="require('@/assets/brees-2012-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees and Saints players standing for the national anthem">
      <br/><br/>
      </div>


<VideoBtn button="Video1" vidName="Video: Brees on breaking Unitas' record" vidUrl="https://www.youtube.com/embed/zQ65CQecQoY">Brees talk about breaking Unitas' record</VideoBtn>
<br/><br/>




<div class="awards-wrapper">
        <div class="awards-headline">2012 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2012 Pro Bowl</li>          
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2012 NFLPA Alan Page Community Award</li>
               
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 

      </div> <!--end text-flex-->
    </div>
  </div>


 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2012 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
</div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2012 Touchdown Tally"> 2012 TOUCHDOWN TALLY</h1>
</div>



</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2012 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2012 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2012 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2012 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2012 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2012 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2012 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2012 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2011">«2011</router-link></div>
  <div class="year-pagination-section year-pagination-current">2012</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2013">2013»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2012',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2012 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2012-top.jpg",
      image1: "brees-2012-slide-1.jpg",
      image2: "brees-2012-slide-2.jpg",
      image3: "brees-2012-slide-3.jpg",
      image4: "brees-2012-slide-4.jpg",
      image5: "brees-2012-slide-5.jpg",
      image6: "brees-2012-slide-6.jpg",
      image7: "brees-2012-slide-7.jpg",
      image8: "brees-2012-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2012;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

  mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 96.3,
                  y: 5177,
                  r: 43/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 98.7,
                  y: 4827,
                  r: 34/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#024",
        "borderColor": "#FB4F14",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 105.8,
                  y: 4659,
                  r: 37/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 108.0,
                  y: 4295,
                  r: 39/1.5
                }
              ]
      },
       {
        "label": "Tony Romo",
        "backgroundColor": "#041E42",
        "borderColor": "#869397",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 90.5,
                  y: 4903,
                  r: 28/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' QB Rating, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Quarterback Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2012.vue